import { render, staticRenderFns } from "./icon-youtube.vue?vue&type=template&id=1ccc4aee&scoped=true&"
import script from "./icon-youtube.vue?vue&type=script&lang=js&"
export * from "./icon-youtube.vue?vue&type=script&lang=js&"
import style0 from "./icon-youtube.vue?vue&type=style&index=0&id=1ccc4aee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccc4aee",
  null
  
)

export default component.exports